import { useTranslation } from "react-i18next";
import { Target, Search, Map, TrendingUp } from "lucide-react";

const STEPS = [
    { key: "step1", icon: Target, color: "bg-violet-100 text-violet-600" },
    { key: "step2", icon: Search, color: "bg-blue-100 text-blue-600" },
    { key: "step3", icon: Map, color: "bg-green-100 text-green-600" },
    { key: "step4", icon: TrendingUp, color: "bg-amber-100 text-amber-600" },
];

export default function PmfRoadmap() {
    const { t } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-xl border border-slate-200 p-6">
                <h3 className="text-lg font-semibold text-slate-900 mb-1">{t("survey.admin.road.title")}</h3>
                <p className="text-sm text-slate-500 mb-6">{t("survey.admin.road.desc")}</p>
                <div className="space-y-4">
                    {STEPS.map(({ key, icon: Icon, color }, i) => (
                        <div key={key} className="flex gap-4 items-start">
                            <div className={`flex-shrink-0 w-10 h-10 rounded-lg ${color} flex items-center justify-center`}>
                                <Icon className="w-5 h-5" />
                            </div>
                            <div className="flex-1 pb-4 border-b border-slate-100 last:border-0">
                                <h4 className="text-sm font-semibold text-slate-900 mb-1">
                                    {t(`survey.admin.road.${key}Title`)}
                                </h4>
                                <p className="text-sm text-slate-500 leading-relaxed">
                                    {t(`survey.admin.road.${key}Desc`)}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">
                <h4 className="text-sm font-semibold text-slate-700 mb-1">{t("survey.admin.road.sourceTitle")}</h4>
                <p className="text-sm text-slate-500">{t("survey.admin.road.sourceDesc")}</p>
            </div>
        </div>
    );
}
